import Cookie from 'cookie.js'
export default function() {
    $(".bsm-btn").click()

    $(".bsm button, .bsm a, .bsm").click(function() {
        Cookie.set('change_body_state', true)
    })

}